export enum EntityNameEnum {
    Customer = 'Customer',
    QualityManagement = 'QualityManagement',
    Device = 'Device',
    AppUser = 'AppUser',
    TaskCheck = 'TaskCheck',
    TaskCheckSignature = 'TaskCheckSignature',
    User = 'User',
    ViolationType = 'ViolationType',
    ViolationDetail = 'ViolationDetail',
    ViolationDetailTaskCheck = 'ViolationDetailTaskCheck',
    ErrorType = 'ErrorType',
    ErrorDetail = 'ErrorDetail',
    ErrorDetailTaskCheck = 'ErrorDetailTaskCheck',
    PartType = 'PartType',
    PartGroup = 'PartGroup',
    PartCategory = 'PartCategory',
    PartSKU = 'PartSKU',
    DeviceType = 'DeviceType',
    DeviceGroup = 'DeviceGroup',
    DeviceModel = 'DeviceModel',
    DeviceSKU = 'DeviceSKU',
    Translation = 'Translation',
}
